// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background: #f0f2f5;
  font-family: 'Arial', sans-serif;
  margin: 0;
  padding: 0;
}

p {
  margin-top: 2px;
  margin-bottom: 2px;
  font-size: small;
}


.container {
  max-width: 820px; /* Formulaire plus large */
  margin: 40px auto;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.header {
  background: #564C8F;
  color: #fff;
  /*padding: 20px;*/
  text-align: center;
}

.subtitle {
  font-size: 1.1rem;
  margin-top: 10px;
}

.form-card {
  padding: 20px;
}

.form-group {
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
}

.form-group label {
  margin-bottom: 5px;
  font-weight: bold;
}

.form-group input[type="text"],
.form-group input[type="password"],
.form-group input[type="file"] {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
}

/* Pour les cases à cocher : on affiche le texte à gauche et la case à droite */
.checkbox-group {
  display: flex;
  gap: 20px;
}

.checkbox-label {
  display: flex;
  align-items: center;
}

.checkbox-label input[type="checkbox"] {
  margin-left: 10px; /* Espace entre le texte (à gauche) et la case */
}


.error {
  color: #d9534f;
  font-weight: bold;
  margin-bottom: 10px;
}

.result-card {
  background: #f8f9fa;
  border-top: 1px solid #ddd;
  padding: 1px;
  margin: 2px;
  text-align: center;
}

.result-card code {
  display: block;
  background: #e9ecef;
  padding: 10px;
  border-radius: 4px;
  margin-top: 10px;
  font-size: small;
}

.footer {
  background: #f1f1f1;
  padding: 10px;
  text-align: center;
  font-size: 0.9rem;
  color: #666;
}

.ttl-group {
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
}

.ttl-inputs {
  display: flex;
  gap: 10px;
  margin-top: 5px;
}

.ttl-inputs input[type="number"] {
  width: 80px;
}

/* Style pour le conteneur d'input de mot de passe */
.password-input-container {
  position: relative;
  display: flex;
  align-items: center;
}

.password-input-container input {
  flex: 1 1;
  padding-right: 40px; /* Espace pour le bouton */
}

/* Style pour le bouton de basculement */
.password-toggle-button {
  position: absolute;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1.2rem;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.password-toggle-button:hover {
  opacity: 0.8;
}

.password-toggle-button:focus {
  outline: none;
}


/* Modifiez ces styles dans votre fichier App.css */

.copy-section {
  display: flex;
  align-items: center;
  margin: 1px 0;
}

.link-container {
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 10px;
}

.link-text {
  flex: 1 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 10px;
  padding: 8px;
  background: #f5f5f5;
  border-radius: 4px;
  border: 1px solid #ddd;
  font-size:small;
}

.code-container {
  position: relative;
  width: 100%;
  margin: 10px 0;
  background: #e9ecef;
  /*padding: 15px;*/
  border-radius: 4px;
  display: flex;
  align-items: center;
}

.code-container code {
  flex: 1 1;
  overflow-x: auto;
}

.copy-button {
  /*background: #567596;*/
  color: white;
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  font-size: small;
  cursor: pointer;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
  min-width: unset;
}

.copy-button:hover {
  background: #774C8F;
}

.copy-button.copied {
  background: #4C8F56;
}

.copy-icon {
  font-size: 16px;
}

.decrypt-section {
  margin-top: 20px;
}

.file-input-label {
  display: inline-block;
  background: #564C8F;
  color: white;
  padding: 10px 15px;
  font-size: 1rem;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.3s ease;
  text-align: center;
}

.file-input-label:hover {
  background: #774C8F;
}

.file-input {
  display: none; /* Cache l'input natif */
}


.ttl-inputs {
  display: flex;
  align-items: center;
  gap: 10px;
}

.ttl-inputs input[type="number"] {
  width: 80px;
  padding: 8px;
  border: 1px solid #564C8F;
  border-radius: 4px;
  font-size: 1rem;
  text-align: center;
  transition: border 0.3s ease, box-shadow 0.3s ease;
}

.ttl-inputs input[type="number"]:focus {
  outline: none;
  border-color: #774C8F;
  box-shadow: 0 0 5px rgba(119, 76, 143, 1);
}

.ttl-inputs select {
  padding: 8px;
  border: 1px solid #564C8F;
  border-radius: 4px;
  font-size: 1rem;
  background: white;
  cursor: pointer;
  transition: border 0.3s ease, box-shadow 0.3s ease;
}

.ttl-inputs select:focus {
  outline: none;
  border-color: #564C8F;
  box-shadow: 0 0 5px rgba(119, 76, 143, 1);
}

.banner-image {
  width: 100%;
  max-height: 213px;
  object-fit: cover;
  border-radius: 8px 8px 0 0;
}


.spinner {
  width: 40px;
  height: 40px;
  border: 5px solid rgba(0, 0, 0, 0.1);
  border-top: 5px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 10px auto;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.all-copy-section {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
  justify-content: center;
}

.copy-all-button {
  background: #4C8F56;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 10px 15px;
  font-size: small;
  cursor: pointer;
  transition: background-color 0.2s;
}

.copy-all-button:hover {
  background: #218838;
}

.button-group {
  display: flex;
  justify-content: center;
  align-items: center; 
  gap: 10px;
  margin-top: 10px;
}

.upload-button,
.reset-button {
  padding: 12px 20px;
  font-size: 1rem;
  line-height: 1.2;    
  border: none;
  border-radius: 4px;
  cursor: pointer;
}


.reset-button {
  background: #4C638F; 
  color: #fff;
  cursor: pointer;
  transition: background-color 0.2s;
}

.reset-button:hover {
  background: #3d5073;
}


.upload-button {
  background: #4C8F56;
  color: #fff;
}

.upload-button:hover {
  background: #305b36;
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;;AAGA;EACE,gBAAgB,EAAE,0BAA0B;EAC5C,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;;EAGE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,+EAA+E;AAC/E;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB,EAAE,gDAAgD;AACrE;;;AAGA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA,oDAAoD;AACpD;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,mBAAmB,EAAE,0BAA0B;AACjD;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;;AAGA,mDAAmD;;AAEnD;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa,EAAE,wBAAwB;AACzC;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,0BAA0B;AAC5B;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;;AAGA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["body {\n  background: #f0f2f5;\n  font-family: 'Arial', sans-serif;\n  margin: 0;\n  padding: 0;\n}\n\np {\n  margin-top: 2px;\n  margin-bottom: 2px;\n  font-size: small;\n}\n\n\n.container {\n  max-width: 820px; /* Formulaire plus large */\n  margin: 40px auto;\n  background: #fff;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n}\n\n.header {\n  background: #564C8F;\n  color: #fff;\n  /*padding: 20px;*/\n  text-align: center;\n}\n\n.subtitle {\n  font-size: 1.1rem;\n  margin-top: 10px;\n}\n\n.form-card {\n  padding: 20px;\n}\n\n.form-group {\n  margin-bottom: 15px;\n  display: flex;\n  flex-direction: column;\n}\n\n.form-group label {\n  margin-bottom: 5px;\n  font-weight: bold;\n}\n\n.form-group input[type=\"text\"],\n.form-group input[type=\"password\"],\n.form-group input[type=\"file\"] {\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 1rem;\n}\n\n/* Pour les cases à cocher : on affiche le texte à gauche et la case à droite */\n.checkbox-group {\n  display: flex;\n  gap: 20px;\n}\n\n.checkbox-label {\n  display: flex;\n  align-items: center;\n}\n\n.checkbox-label input[type=\"checkbox\"] {\n  margin-left: 10px; /* Espace entre le texte (à gauche) et la case */\n}\n\n\n.error {\n  color: #d9534f;\n  font-weight: bold;\n  margin-bottom: 10px;\n}\n\n.result-card {\n  background: #f8f9fa;\n  border-top: 1px solid #ddd;\n  padding: 1px;\n  margin: 2px;\n  text-align: center;\n}\n\n.result-card code {\n  display: block;\n  background: #e9ecef;\n  padding: 10px;\n  border-radius: 4px;\n  margin-top: 10px;\n  font-size: small;\n}\n\n.footer {\n  background: #f1f1f1;\n  padding: 10px;\n  text-align: center;\n  font-size: 0.9rem;\n  color: #666;\n}\n\n.ttl-group {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 15px;\n}\n\n.ttl-inputs {\n  display: flex;\n  gap: 10px;\n  margin-top: 5px;\n}\n\n.ttl-inputs input[type=\"number\"] {\n  width: 80px;\n}\n\n/* Style pour le conteneur d'input de mot de passe */\n.password-input-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.password-input-container input {\n  flex: 1;\n  padding-right: 40px; /* Espace pour le bouton */\n}\n\n/* Style pour le bouton de basculement */\n.password-toggle-button {\n  position: absolute;\n  right: 10px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 1.2rem;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n}\n\n.password-toggle-button:hover {\n  opacity: 0.8;\n}\n\n.password-toggle-button:focus {\n  outline: none;\n}\n\n\n/* Modifiez ces styles dans votre fichier App.css */\n\n.copy-section {\n  display: flex;\n  align-items: center;\n  margin: 1px 0;\n}\n\n.link-container {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  margin-bottom: 10px;\n}\n\n.link-text {\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  margin-right: 10px;\n  padding: 8px;\n  background: #f5f5f5;\n  border-radius: 4px;\n  border: 1px solid #ddd;\n  font-size:small;\n}\n\n.code-container {\n  position: relative;\n  width: 100%;\n  margin: 10px 0;\n  background: #e9ecef;\n  /*padding: 15px;*/\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n}\n\n.code-container code {\n  flex: 1;\n  overflow-x: auto;\n}\n\n.copy-button {\n  /*background: #567596;*/\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 32px;\n  height: 32px;\n  font-size: small;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: 10px;\n  min-width: unset;\n}\n\n.copy-button:hover {\n  background: #774C8F;\n}\n\n.copy-button.copied {\n  background: #4C8F56;\n}\n\n.copy-icon {\n  font-size: 16px;\n}\n\n.decrypt-section {\n  margin-top: 20px;\n}\n\n.file-input-label {\n  display: inline-block;\n  background: #564C8F;\n  color: white;\n  padding: 10px 15px;\n  font-size: 1rem;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background 0.3s ease;\n  text-align: center;\n}\n\n.file-input-label:hover {\n  background: #774C8F;\n}\n\n.file-input {\n  display: none; /* Cache l'input natif */\n}\n\n\n.ttl-inputs {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.ttl-inputs input[type=\"number\"] {\n  width: 80px;\n  padding: 8px;\n  border: 1px solid #564C8F;\n  border-radius: 4px;\n  font-size: 1rem;\n  text-align: center;\n  transition: border 0.3s ease, box-shadow 0.3s ease;\n}\n\n.ttl-inputs input[type=\"number\"]:focus {\n  outline: none;\n  border-color: #774C8F;\n  box-shadow: 0 0 5px rgba(119, 76, 143, 1);\n}\n\n.ttl-inputs select {\n  padding: 8px;\n  border: 1px solid #564C8F;\n  border-radius: 4px;\n  font-size: 1rem;\n  background: white;\n  cursor: pointer;\n  transition: border 0.3s ease, box-shadow 0.3s ease;\n}\n\n.ttl-inputs select:focus {\n  outline: none;\n  border-color: #564C8F;\n  box-shadow: 0 0 5px rgba(119, 76, 143, 1);\n}\n\n.banner-image {\n  width: 100%;\n  max-height: 213px;\n  object-fit: cover;\n  border-radius: 8px 8px 0 0;\n}\n\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 5px solid rgba(0, 0, 0, 0.1);\n  border-top: 5px solid #007bff;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin: 10px auto;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.all-copy-section {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 10px;\n  justify-content: center;\n}\n\n.copy-all-button {\n  background: #4C8F56;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 10px 15px;\n  font-size: small;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.copy-all-button:hover {\n  background: #218838;\n}\n\n.button-group {\n  display: flex;\n  justify-content: center;\n  align-items: center; \n  gap: 10px;\n  margin-top: 10px;\n}\n\n.upload-button,\n.reset-button {\n  padding: 12px 20px;\n  font-size: 1rem;\n  line-height: 1.2;    \n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n\n.reset-button {\n  background: #4C638F; \n  color: #fff;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.reset-button:hover {\n  background: #3d5073;\n}\n\n\n.upload-button {\n  background: #4C8F56;\n  color: #fff;\n}\n\n.upload-button:hover {\n  background: #305b36;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
